'use client';

import { useEffect } from 'react';

export function AppInfo() {
  useEffect(() => {
    console.group('Sollis Health');
    console.info('version:', process.env.NEXT_PUBLIC_APP_VERSION);
    console.info('environment:', process.env.NEXT_PUBLIC_NODE_ENV);
    console.groupEnd();
  }, []);

  return null;
}
